import React, { useState } from "react";
import "./CitasFuturasTable.css";

export default function CitasFuturasTable({
  citas,
  isAdmin,
  dateFilter,
  setDateFilter,
  handleDeleteCita,
}) {
  const PAGE_SIZE = 5;
  const [page, setPage] = useState(1);

  const filtered = citas.filter((c) => {
    if (!dateFilter) return true;
    const fecha = new Date(c.start_datetime).toISOString().slice(0, 10);
    return fecha === dateFilter;
  });

  const totalPages = Math.ceil(filtered.length / PAGE_SIZE);
  const start = (page - 1) * PAGE_SIZE;
  const items = filtered.slice(start, start + PAGE_SIZE);

  return (
    <>
      <div className="pv-filter">
        <input
          type="date"
          value={dateFilter}
          onChange={(e) => setDateFilter(e.target.value)}
        />
        {dateFilter && (
          <button className="clear-btn" onClick={() => setDateFilter("")}>
            Limpiar
          </button>
        )}
      </div>

      {filtered.length === 0 ? (
        <p>No hay citas programadas por realizar.</p>
      ) : (
        <>
          {/* ✅ Contenedor con scroll responsivo */}
          <div className="pv-table-wrapper">
            <table className="pv-table citas">
              <thead>
                <tr>
                  <th>Fecha</th>
                  <th>Inicio</th>
                  <th>Fin</th>
                  <th>Especialidad</th>
                  <th>Servicio</th>
                  <th>Tipo</th>
                  {isAdmin && <th>Acciones</th>}
                </tr>
              </thead>
              <tbody>
                {items.map((c) => {
                  const start = new Date(c.start_datetime);
                  const end = new Date(c.end_datetime);
                  return (
                    <tr key={c.id}>
                      <td>{start.toLocaleDateString("es-ES")}</td>
                      <td>
                        {start.toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </td>
                      <td>
                        {end.toLocaleTimeString([], {
                          hour: "2-digit",
                          minute: "2-digit",
                        })}
                      </td>
                      <td>{c.specialty || "-"}</td>
                      <td>{c.service_code || "-"}</td>
                      <td>
                        {c.is_group
                          ? `Grupo (${c.group_size || "-"})`
                          : "Individual"}
                      </td>
                      {isAdmin && (
                        <td style={{ textAlign: "center" }}>
                          <button
                            className="icon-btn danger"
                            onClick={() => handleDeleteCita(c.id)}
                            title="Eliminar cita"
                          >
                            <i className="fa fa-trash" />
                          </button>
                        </td>
                      )}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>

          {totalPages > 1 && (
            <div className="pagination">
              <button onClick={() => setPage(page - 1)} disabled={page === 1}>
                ← Anterior
              </button>
              <span>
                Página {page} de {totalPages}
              </span>
              <button
                onClick={() => setPage(page + 1)}
                disabled={page === totalPages}
              >
                Siguiente →
              </button>
            </div>
          )}
        </>
      )}
    </>
  );
}
